import '../css/_fonts.scss';

import FontFaceObserver from 'fontfaceobserver/fontfaceobserver';

const iconFont = new FontFaceObserver('Material Icons');

iconFont.load('favorite', 5000).then(() => {
	document.documentElement.classList.add('ln-icons-loaded');
});
